import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";

@Component({
  selector: "app-member-chase",
  templateUrl: "./member-chase.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberChaseComponent {
    filters: string[];
    dashboardType = LookerRiskDashboardType.MEMBER_STATUS;

    constructor() {
        this.filters = ["Projects", "MemberId", "MemberFirstName", "MemberLastName",
                        "MemberDob", "MemberKey", "DiagnosisCode", "Products", "LOB", "RetrievalOwner", "ChaseTags"];
    }

}
